// src/socket.js
import { io } from 'socket.io-client';

// 如果沒設環境變數，就用同網域（建議前後端同網域部署，最省事）
const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || undefined;

// 你的 server 是用 path: '/socket.io'
export const socket = io(SOCKET_URL, {
  path: '/socket.io',
  transports: ['websocket'],   // 避免長輪詢，較穩定
  withCredentials: true,       // 若有 cookie 或跨網域需要
});
